import React, {useState, useContext} from "react";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import {Button} from "@mui/material";
import BrushIcon from '@mui/icons-material/Brush';
import LocalHotelIcon from '@mui/icons-material/LocalHotel';
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import { Grid } from "@mui/material";
import UploadCard from "./UploadCard";
import { AppContext } from "../../App";

export default function Submit(){

  const { eventDetails, setEventDetails } = useContext(AppContext)

  const eventDocs = eventDetails.eventDocuments

  return (
    <div className="submit-container">
      <h3>Status</h3>
      <p>At the moment, your booking is still tentative. In order to confirm the booking, please make sure to upload the following documents:</p>
      <p>*required</p>

      <Grid container spacing={0}>
        <Grid item sx={{padding: '0.5em', cursor:'pointer'}} xs={6}>
            <UploadCard name="Contract" docList={eventDocs} icon={ 
            <FileUploadIcon sx={{fontSize:'3em', marginBottom:'0.5em'}}/>} 
            title="Signed Contract"/>
        </Grid>
        <Grid item sx={{padding: '0.5em', cursor:'pointer'}} xs={6}>
            <UploadCard name="Invoice" docList={eventDocs} icon={<FileUploadIcon sx={{fontSize:'3em', marginBottom:'0.5em'}}/>} title="Invoice PoP"/>
        </Grid>
      </Grid>

      <Grid container spacing={0}>
        <Grid sx={{padding: '0.5em', cursor:'pointer'}} xs={6} item={true}>
            <UploadCard name="EventArtwork" docList={eventDocs} icon={ 
            <BrushIcon sx={{fontSize:'3em', marginBottom:'0.5em'}}/>} 
            title="Event Artwork"/>
        </Grid>
        <Grid sx={{padding: '0.5em', cursor:'pointer'}} xs={6} item={true}>
            <UploadCard name="FlightConfirmations" docList={eventDocs} icon={<EmojiTransportationIcon sx={{fontSize:'3em', marginBottom:'0.5em'}}/>} title="Flights & Car"/>
        </Grid>
      </Grid>
      <Grid container spacing={0}>
        <Grid sx={{padding: '0.5em', cursor:'pointer'}} xs={12} item={true}>
            <UploadCard name="HotelReservations" docList={eventDocs} icon={<LocalHotelIcon sx={{fontSize:'3em', marginBottom:'0.5em'}}/>} title="Hotel Confirmations"/>
        </Grid>
      </Grid>
    </div>
  )
}